import { formatDate } from 'utils/helpers/date'
import ActionCellRenderer from './actionCellRenderer'
import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'

export enum FileSourceType {
  INTERNAL_FTP = 'INTERNAL_FTP',
  CHAIN_FTP = 'CHAIN_FTP',
}

export const chainParentFields = {
  FTP: 'ftp',
}

export const chainFormFields = {
  CHAIN_ID: { key: 'chainId', label: 'Chain ID' },
  CHAIN_NAME: { key: 'chainName', label: 'Chain Name' },
  CHAIN_IS_ACTIVE: { key: 'isActive', label: 'Active' },
  FILE_SOURCE_TYPE: { key: 'fileSourceType', label: 'File Source Type' },

  FTP_PROTOCOL: {
    key: 'protocol',
    label: 'Protocol',
    parentKey: chainParentFields.FTP,
  },
  FTP_HOST: {
    key: 'host',
    label: 'FTP Host',
    parentKey: chainParentFields.FTP,
  },
  FTP_PORT: {
    key: 'port',
    label: 'FTP Port',
    parentKey: chainParentFields.FTP,
  },
  FTP_USERNAME: {
    key: 'username',
    label: 'Username',
    parentKey: chainParentFields.FTP,
  },
  FTP_PASSWORD: {
    key: 'password',
    label: 'Password',
    parentKey: chainParentFields.FTP,
  },
  FTP_BASE_DIRECTORY: {
    key: 'baseDirectory',
    label: 'Base Directory / Folder Path',
    parentKey: chainParentFields.FTP,
  },
} as const

export const fileSourceTypeOptions = [
  {
    label: 'Internal FTP',
    value: FileSourceType.INTERNAL_FTP,
    disabled: false,
  },
  { label: 'Chain FTP', value: FileSourceType.CHAIN_FTP, disabled: false },
]

export const getColumns = (
  isEditor: boolean,
  getChainToDelete: (params: ICellRendererParams) => void,
) =>
  [
    {
      headerName: chainFormFields?.CHAIN_NAME?.label,
      field: chainFormFields?.CHAIN_NAME?.key,
      minWidth: 200,
    },
    { headerName: 'ID', field: '_id', minWidth: 120 },
    {
      headerName: chainFormFields?.FILE_SOURCE_TYPE?.label,
      field: chainFormFields.FILE_SOURCE_TYPE.key,
      minWidth: 150,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value === FileSourceType.INTERNAL_FTP
          ? 'Internal FTP'
          : params.value === FileSourceType.CHAIN_FTP
            ? 'Chain FTP'
            : '-',
    },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      headerName: 'Status',
      field: 'isActive',
      cellRenderer: (params: ICellRendererParams) =>
        params?.value === true
          ? 'Active'
          : params?.value === false
            ? 'Inactive'
            : '-',
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'save',
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer
          params={params}
          isEditor={isEditor}
          getChainToDelete={getChainToDelete}
        />
      ),
    },
  ] as ColDef[]
